import { TimingObject } from 'app/_models/common/timing.object';
import { SettingModel } from '../../common/setting.model';
import { UserIdentificationModel } from '../../user.identification.model';
import { AdminSetting } from './admin.setting';
import { SettingsSaveCommand } from './settings.save.command';

export class SettingsBase {
  Title: string;
  CommonSettings: { [key: string]: AdminSetting };
  MoreSpecificSettings: { [key: string]: SettingModel[] };
  SaveCommands: SettingsSaveCommand[];
  UID: UserIdentificationModel;
  Timing: TimingObject;
}
